import ImageBuilding from 'assets/images/Building.svg';
interface props {
    title?: string;
    button?: any;
    isDisplayIcon?: boolean;
}
export const ListNoData = ({
    title = '該当データが見つかりません。',
    button,
    isDisplayIcon = true,
}: props) => {
    return (
        <section className="nodata-container">
            {isDisplayIcon && (
                <div>
                    <img src={ImageBuilding} />
                </div>
            )}
            <div className="nodata-text">{title}</div>
            <div>{button}</div>
        </section>
    );
};
